// extracted by mini-css-extract-plugin
module.exports = {"projetoH1":"Projetos_projetoH1__3XtBy","cardBox":"Projetos_cardBox__3YV8n","card":"Projetos_card__1o0WV","btn":"Projetos_btn__-QhyQ"};